module.exports = __webpack_public_path__ + "static/media/contact-info-icon3.3cf93bcf.svg";